module.exports = __webpack_public_path__ + "25e41662c3fe11da8b0cfcbcb8c577ad.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/ABCMonumentGrotesk-Medium.woff2
// module id = 377
// module chunks = 0